export const salesReviewReturnSections = t => [
  {
    id: 'imovel',
    kind: 'simple',
    title: t('SALES.REVIEW.RETURN_FORM.PROPERTY.TITLE'),
    description: t('SALES.REVIEW.RETURN_FORM.PROPERTY.DESCRIPTION'),
    checksLabel: t('SALES.REVIEW.RETURN_FORM.PROPERTY.CHECKS'),
    checksPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.PROPERTY.CHECKS_PLACEHOLDER'
    ),
    observationLabel: t('SALES.REVIEW.RETURN_FORM.PROPERTY.OBSERVATION'),
    observationPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.PROPERTY.OBSERVATION_PLACEHOLDER'
    ),
  },
  {
    id: 'recibo',
    kind: 'simple',
    title: t('SALES.REVIEW.RETURN_FORM.RECEIPT.TITLE'),
    description: t('SALES.REVIEW.RETURN_FORM.RECEIPT.DESCRIPTION'),
    checksLabel: t('SALES.REVIEW.RETURN_FORM.RECEIPT.CHECKS'),
    checksPlaceholder: t('SALES.REVIEW.RETURN_FORM.RECEIPT.CHECKS_PLACEHOLDER'),
    observationLabel: t('SALES.REVIEW.RETURN_FORM.RECEIPT.OBSERVATION'),
    observationPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.RECEIPT.OBSERVATION_PLACEHOLDER'
    ),
  },
  {
    id: 'vendedor_pf',
    kind: 'party',
    role: 'vendedor',
    kindLabel: 'pf',
    title: t('SALES.REVIEW.RETURN_FORM.SELLER_PF.TITLE'),
    description: t('SALES.REVIEW.RETURN_FORM.SELLER_PF.DESCRIPTION'),
    quantityLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PF.QUANTITY'),
    personLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PF.PERSON'),
    checksLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PF.CHECKS'),
    checksPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.SELLER_PF.CHECKS_PLACEHOLDER'
    ),
    observationLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PF.OBSERVATION'),
    observationPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.SELLER_PF.OBSERVATION_PLACEHOLDER'
    ),
  },
  {
    id: 'vendedor_pj',
    kind: 'party',
    role: 'vendedor',
    kindLabel: 'pj',
    title: t('SALES.REVIEW.RETURN_FORM.SELLER_PJ.TITLE'),
    description: t('SALES.REVIEW.RETURN_FORM.SELLER_PJ.DESCRIPTION'),
    quantityLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PJ.QUANTITY'),
    personLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PJ.PERSON'),
    checksLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PJ.CHECKS'),
    checksPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.SELLER_PJ.CHECKS_PLACEHOLDER'
    ),
    observationLabel: t('SALES.REVIEW.RETURN_FORM.SELLER_PJ.OBSERVATION'),
    observationPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.SELLER_PJ.OBSERVATION_PLACEHOLDER'
    ),
  },
  {
    id: 'comprador_pf',
    kind: 'party',
    role: 'comprador',
    kindLabel: 'pf',
    title: t('SALES.REVIEW.RETURN_FORM.BUYER_PF.TITLE'),
    description: t('SALES.REVIEW.RETURN_FORM.BUYER_PF.DESCRIPTION'),
    quantityLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PF.QUANTITY'),
    personLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PF.PERSON'),
    checksLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PF.CHECKS'),
    checksPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.BUYER_PF.CHECKS_PLACEHOLDER'
    ),
    observationLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PF.OBSERVATION'),
    observationPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.BUYER_PF.OBSERVATION_PLACEHOLDER'
    ),
  },
  {
    id: 'comprador_pj',
    kind: 'party',
    role: 'comprador',
    kindLabel: 'pj',
    title: t('SALES.REVIEW.RETURN_FORM.BUYER_PJ.TITLE'),
    description: t('SALES.REVIEW.RETURN_FORM.BUYER_PJ.DESCRIPTION'),
    quantityLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PJ.QUANTITY'),
    personLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PJ.PERSON'),
    checksLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PJ.CHECKS'),
    checksPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.BUYER_PJ.CHECKS_PLACEHOLDER'
    ),
    observationLabel: t('SALES.REVIEW.RETURN_FORM.BUYER_PJ.OBSERVATION'),
    observationPlaceholder: t(
      'SALES.REVIEW.RETURN_FORM.BUYER_PJ.OBSERVATION_PLACEHOLDER'
    ),
  },
];

export const sectionForParticipant = participant => {
  const kind = participant?.kind === 'pessoa_juridica' ? 'pj' : 'pf';
  return `${participant?.role}_${kind}`;
};

export const participantsForSection = (participants, section) =>
  participants.filter(
    participant => sectionForParticipant(participant) === section
  );

export const catalogKeyForParticipant = (section, participant) => {
  if (participant?.relation_type === 'representante') return 'representante';
  return section.endsWith('_pf') ? 'pf' : 'pj';
};

export const checkId = check =>
  String(check?.id ?? check?.id_correcao ?? check);
